import React from "react"
import { makeStyles } from "@material-ui/styles"
import { NavLink } from "react-router-dom"
import { Box } from "@material-ui/core"
import { ActionCard } from "./ActionCard"
import { UnconfirmedChip } from ".."
import NotificationMessage from "../NotificationList/NotificationMessage"
import { useNotificationUtils } from "../../utils"
import { RowBox } from "../Boxes"
import { Icon } from "../Icon"

const useStyles = makeStyles((theme) => ({
  chip: {
    marginRight: theme.spacing(1),
  },
  message: {
    color: theme.palette.text.main,
    fontSize: 14,
    lineHeight: "18px",
    "&>strong": {
      color: theme.palette.mentions.mention,
    },
    marginBottom: 8,
  },
  actionRaisedIcon: {
    color: theme.palette.raised.main,
  },
}))

const UnresolvedActionActionCard = ({ notification }) => {
  const classes = useStyles()
  const { getNavigateToLink } = useNotificationUtils()

  return (
    <ActionCard
      title={notification.action?.title || ""}
      detail={<NotificationMessage notification={notification} className={classes.message} showMessage={false} />}
      cardProps={{ component: NavLink, to: { pathname: getNavigateToLink(notification) } }}
      rightChildren={
        <Box mt={-0.5} mr={-0.5}>
          <Icon name="action-raised" className={classes.actionRaisedIcon} />
        </Box>
      }
    >
      <RowBox>
        <UnconfirmedChip label="Unresolved" className={classes.chip} />
      </RowBox>
    </ActionCard>
  )
}

export { UnresolvedActionActionCard }
